import { DiscoveryPage } from '@/features/discovery/pages/discovery-page';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const searchParams = z.object({
  search_id: z.string().optional(),
});

export const Route = createFileRoute('/workspace/$workspaceId/discovery/')({
  validateSearch: searchParams,
  component: DiscoveryPage,
});
